export default "__VITE_ASSET__W$8pCBxgan7uEwotQA0Z$w__"